<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import PageEditorBeta from '@/views/PageEditorBeta.vue'
import PageEditorLegacy from '@/views/PageEditorLegacy.vue'
import { hasBetaEditorQuery } from '@/utils/editor-variant'

const router = useRouter()

const isBetaEditor = computed(() => hasBetaEditorQuery(router.currentRoute.value.query))
</script>

<template>
    <page-editor-beta v-if="isBetaEditor" />
    <page-editor-legacy v-else />
</template>
